import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Col, Row, Table, Grid, Divider } from "antd";
import { PageName, SearchContainer, SearchIcon, SearchInput, SearchButton, StyledCard , TermsWrapper} from './style';
import { MyText } from "../../components";
import {useTranslation} from "react-i18next";
import { UserAgreementPageKz } from "./kk";
import { UserAgreementPageRu } from "./ru";
import { useLang } from "../../utils/context/lang";


export const UserAgreementPage = () => {
  const {handleChangeLang, lang} = useLang()
  
  return lang === "kk" ? <UserAgreementPageKz /> : <UserAgreementPageRu />;
};
